import {ChallengeResultTaskDto, UserResponseDto} from "../api/model/user-response-dto";
import {WorkerPool} from "./worker-pool";

export class PowSolver {
  private workerPool: WorkerPool;

  constructor() {
    this.workerPool = new WorkerPool();
  }

  public async solveTasks(userResponseDto: UserResponseDto): Promise<ChallengeResultTaskDto[]> {
    const promises = userResponseDto.challenge.tasks.map(task =>
      this.workerPool.enqueue(task, userResponseDto.challenge.difficulty)
    );
    return Promise.all(promises);
  }

  public reset(): void {
    this.workerPool.reset();
  }
}
